import DamzDropdownWrapper from './DamzDropdownWrapper';
import NotificationsDropdownWrapperContainer from './DamzDropdownWrapper.container';
export default NotificationsDropdownWrapperContainer(DamzDropdownWrapper);

//# sourceMappingURL=index.js.map